import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { authApi } from "./services/auth";
import authSlice from "./slices/auth/authSlice"
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import userSlice from "./slices/user/userSlice";
import { commonApi } from "./services/common";
import { profileApi } from "./services/profile";
import { happCoachApi } from "./services/happcoach";
import { companyApi } from "./services/company";
import { userApi } from "./services/user";
import { messagingApi } from "./services/messages";

const persistConfig = {
    key: 'root', 
    storage, 
    whitelist:['auth',]
};
const rootReducer = combineReducers({
    [authApi.reducerPath]: authApi.reducer,
    [happCoachApi.reducerPath]: happCoachApi.reducer,
    [commonApi.reducerPath]: commonApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [messagingApi.reducerPath]: messagingApi.reducer,
    auth: authSlice,
    user: userSlice
  });
  const persistedReducer = persistReducer(persistConfig, rootReducer);
export const createStore = (options) =>
  configureStore({
    reducer:persistedReducer ,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(authApi.middleware, happCoachApi.middleware, commonApi.middleware,profileApi.middleware ,userApi.middleware, companyApi.middleware, messagingApi.middleware  ),
    ...options
  });

export const store = createStore();
export const persistor = persistStore(store);

export const useAppDispatch = () => useDispatch();
export const useTypedSelector =()=> useSelector();

